import { ReactNode, useEffect, useState } from 'react';

import { initializeAuth } from '@/context/application.actions';
import { useApplication } from '@/context/application.provider';

interface SessionMiddlewareProps {
  children: ReactNode;
}

const SessionMiddleware = ({ children }: SessionMiddlewareProps) => {
  const { applicationDispatch } = useApplication();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    applicationDispatch(initializeAuth());
    setIsInitialized(true);
  }, [applicationDispatch]);

  if (!isInitialized) {
    return null;
  }

  return children;
};

export default SessionMiddleware;
